import { render, staticRenderFns } from "./CostCentersItem.vue?vue&type=template&id=67a17e10&lang=pug&"
import script from "./CostCentersItem.vue?vue&type=script&lang=js&"
export * from "./CostCentersItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports